require('./kovFormGroup.scss');

module.exports = require('./kovFormGroup.js');

//const KovFormGroup = require('./kovFormGroup.js');

/*module.exports = {
  template: require('./kovFormGroup.html'),
  controllerAs: 'ctrl',
  controller: KovFormGroup,
  transclude: true,
  bindings: {
    sLabel: '@',
    sHelpText: '@',
    sLabelWidth: '@',
    sInputWidth: '@',
    sRequired: '<',
    sErrors: '<'
  }
};*/